import { render, staticRenderFns } from "./iristarJoinUs.vue?vue&type=template&id=fd918044&scoped=true&"
import script from "./iristarJoinUs.vue?vue&type=script&lang=js&"
export * from "./iristarJoinUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd918044",
  null
  
)

export default component.exports